import React, { useEffect, useState } from 'react'
// redux
import { useSelector, useDispatch } from 'react-redux';
import { obtenerUsuario, actualizarImagen, getImagen, actualizarCuenta } from '../../actions/usersActions';
import { LoaderSpinner } from '../../components/LoaderSpinner';
import clienteAxios from '../../config/axios';
import Swal from 'sweetalert2';
import $ from 'jquery'

export const Perfil = () => {
    const d = new Date();

    const dispatch = useDispatch()
    const [busco, setBusco] = useState(false);

    const [file, setFile] = useState();
    const [fileName, setFileName] = useState("");
    const [img, setImg] = useState(null);

    // 2FA state
    const [show2FAConfig, setShow2FAConfig] = useState(false);
    const [qrCode, setQrCode] = useState(null);
    const [secret, setSecret] = useState(null);
    const [codigo2FA, setCodigo2FA] = useState('');

    const [currentUser, setCurrentUser] = useState({
        nombre: '',
        email: '',
        telefono: '',
        password: ''
    });
    const user = useSelector(state => state.auth.user)
    const loading = useSelector(state => state.auth.loading)
    const search_custom_page = useSelector(state => state.landings.search_custom_page)


    useEffect(async () => {
        if (busco === false) {

            if (user) {
                console.log('user', user)
                setCurrentUser({
                    id: user.id,
                    nombre: user.name,
                    email: user.email,
                    telefono: user.telefono
                });

                setImg(`${process.env.REACT_APP_BACKEND}/users/getImage/${user.id}`)
            }

            setBusco(true);
        }
        if (search_custom_page == null) {
            $('#loading').hide();
        }

    }, [user, search_custom_page])

    const saveFile = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
    };

    const handleChange = (e) => {
        setCurrentUser({
            ...currentUser,
            [e.target.name]: e.target.value
        })
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        //    console.log('submit');
        const u = {
            id: user.id,
            nombre: currentUser.nombre,
            telefono: currentUser.telefono,
            password: currentUser.password
        }
        dispatch(actualizarCuenta({ new_account: u }))
    }

    const onFormSubmit = async (e) => {
        e.preventDefault();
        await dispatch(actualizarImagen(file, fileName))
        setTimeout(() => {
            const d = new Date();

            setImg(`${process.env.REACT_APP_BACKEND}/users/getImage/${user.id}?${d.getTime()}`)
        }, 1000)
    }

    // 2FA Handlers
    const handleEnable2FA = async () => {
        try {
            const res = await clienteAxios.get(`/users/generate-2fa/${user.id}`);
            setQrCode(res.data.qrCode);
            setSecret(res.data.secret);
            setShow2FAConfig(true);
        } catch (error) {
            Swal.fire('Error', 'No se pudo generar el código QR', 'error');
        }
    }

    const handleVerify2FA = async () => {
        try {
            await clienteAxios.post(`/users/validar-2fa/${user.id}`, { codigo2FA });
            Swal.fire('¡Éxito!', 'La autenticación de dos factores ha sido activada.', 'success');
            setShow2FAConfig(false);
            window.location.reload(); // To refresh user data and show "Disabled" button
        } catch (error) {
            Swal.fire('Error', error.response.data.message || 'Código incorrecto', 'error');
        }
    }

    const handleDisable2FA = async () => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Esto desactivará la protección extra de tu cuenta.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, desactivar',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await clienteAxios.get(`/users/desactivar-2fa/${user.id}`);
                    Swal.fire('Desactivado', 'El 2FA ha sido desactivado.', 'success');
                    window.location.reload();
                } catch (error) {
                    Swal.fire('Error', 'No se pudo desactivar el 2FA', 'error');
                }
            }
        });
    }

    return (
        <div className="white_box QA_section card_height_100">
            <h4 className="p-3 naranja">Perfil</h4>
            {
                loading ? <LoaderSpinner /> : null
            }

            <div className="row mt-5 mb-5">
                <div className="col-md-4">

                    {
                        user ?
                            <img src={`${process.env.REACT_APP_BACKEND}/users/getImage/${user.id}?${d.getTime()}`} className="img-circle elevation-2 mb-5" width="250" alt="User " />
                            : <img src={`${process.env.REACT_APP_USER_IMAGE}`} className="img-circle elevation-2 mb-5" width="250" alt="User " />
                    }

                    <form onSubmit={onFormSubmit} className="mb-5">
                        <div className="form-group">
                            <label>Subir Imagen</label><br></br>
                            <input type="file" name="myImage" onChange={saveFile} />
                        </div>
                        <button type="submit" className="btn btn-success">Subir</button>
                    </form>

                    <hr />

                    <div className="mt-4">
                        <h5 className="naranja">Seguridad (2FA)</h5>
                        {user?.twoFactorSecret ? (
                            <div className="alert alert-success">
                                <p><i className="fa fa-check-circle"></i> La autenticación de dos factores está <strong>activada</strong>.</p>
                                <button className="btn btn-danger btn-sm" onClick={handleDisable2FA}>Desactivar 2FA</button>
                            </div>
                        ) : (
                            <div className="alert alert-light border">
                                <p>Protege tu cuenta con un segundo factor de autenticación.</p>
                                {!show2FAConfig ? (
                                    <button className="btn btn-info btn-sm" onClick={handleEnable2FA}>Configurar 2FA</button>
                                ) : (
                                    <div className="text-center">
                                        <p className="small">Escanea el código QR con Google Authenticator o Authy:</p>
                                        <div dangerouslySetInnerHTML={{ __html: qrCode }} style={{ maxWidth: '200px', margin: '0 auto' }} />
                                        <p className="mt-2 small">O ingresa manualmente: <strong>{secret}</strong></p>
                                        <div className="form-group mt-3">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm text-center"
                                                placeholder="Código de 6 dígitos"
                                                value={codigo2FA}
                                                onChange={(e) => setCodigo2FA(e.target.value)}
                                            />
                                        </div>
                                        <button className="btn btn-success btn-sm btn-block" onClick={handleVerify2FA}>Verificar y Activar</button>
                                        <button className="btn btn-link btn-sm text-muted" onClick={() => setShow2FAConfig(false)}>Cancelar</button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-4">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Nombre</label>
                            <input type="text" name="nombre" value={currentUser.nombre} onChange={handleChange} className="form-control-lg form-control" />
                        </div>
                        <div className="form-group">
                            <label>Teléfono</label>
                            <input type="text" name="telefono" value={currentUser.telefono} onChange={handleChange} className="form-control-lg form-control" />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="email" name="email" value={currentUser.email} onChange={handleChange} className="form-control-lg form-control" />
                        </div>
                        <div className="form-group">
                            <label>Contraseña</label>
                            <input type="password" name="password" value={currentUser.password} onChange={handleChange} className="form-control-lg form-control" />
                        </div>
                        <input type="submit" value="Actualizar" className="btn btn-success" />
                    </form>
                </div>
            </div>
        </div>
    )
}
